<template>
  <!-- 毕业条件 -->
  <div>
    <home-header></home-header>
    <div class="content page-width">
      <personal-center></personal-center>
      <div class="margin-top-30"></div>
      <Condition></Condition>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from "@/common/components/Header";
import Foot from "@/common/components/Foot";
import Condition from "./components/Condition";
import PersonalCenter from "@/common/components/PersonalCenter";
export default {
  name: "GraduatonCondition",
  components: {
    HomeHeader,
    Foot,
    Condition,
    PersonalCenter
  },
  data: function () {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.page-width{
  width:$pageWidth;
  margin:0 auto;
  .content-right{
    margin-top:30px;
    .localtion{
      line-height 30px;
      border-bottom:1px solid $borderColor;
      margin-bottom:20px;
    }
  }
}
.content-left{
  background:#f7f6f6;
}
</style>



// WEBPACK FOOTER //
// src/pages/graduatonCondition/index.vue